<template>
	<div class="network">
		<div class="intro">
			<h2>Network</h2>
			
		</div>

		<div style="margin:20px 0;">
			<el-form :inline="true" class="demo-form-inline">
				<el-form-item label="Please select">
					<el-select v-model="SelectType" @change="selectTypeChange" placeholder="Please select">
						<el-option label="Compound" value="Compound"></el-option>
						<el-option label="Target" value="Target"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="warning" @click="browseClick" :disabled="BrowseDisabled">Browse</el-button>
				</el-form-item>

				<el-form-item label="">
					<el-input placeholder="CHEMBL_ID" v-model="CHEMBL_ID" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit" :disabled="SubmitDisabled">Submit</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div class="el-row mainContent">
			<div class="el-col el-col-9">
				<div class="nodes" id="config"></div>
			</div>
			<div class="el-col el-col-15">
				<div id="legend1">
					<ul class="legend2">
						<li class="lili" style="font-size: 20px;text-align: center;line-height: 30px;"> Legend </li>
						
						<li class="lili" style="padding-left: 12px;line-height: 31px;">
							<div style="height:20px;width: 20px;background: #97C2FC "></div> Target_ChEMBL
						</li>
						<li class="lili" style="padding-left: 12px;line-height: 31px;">
							<div style="height:20px;width: 20px;background: #FFFFA3 "></div> NP_ChEMBL
						</li>
					</ul>
				</div>
				<div class="legend" id="mynetwork">右</div>
			</div>


		</div>
		<el-dialog title="Please Click to Select a Master Node" :close-on-click-modal="false"
			:visible.sync="dialogTableVisible">
			<div class="el-col el-col-6"
				style="padding-left: 10px; padding-right: 10px; position: absolute; right: 100px; top: 12px;">
				<div class="search el-input">
					<!----><input type="text" autocomplete="off" placeholder="Search" icon="search"
						class="el-input__inner" v-model="key" @input="keychange">
					<!---->
					<!---->
					<!---->
					<!---->
				</div>
			</div>
			<el-table :data="showData" style="font-size: 18px;">
				<el-table-column v-loading="loading" prop="Inflam_id" label="ID" width="200px" >
					<template slot-scope="scope">
						<el-link type="primary" style="font-size: 18px;" @click="selectChembl(scope.row.ChEMBL_ID)">{{scope.row.ChEMBL_ID}}
						</el-link>
					</template>
				</el-table-column width="200px">
				<el-table-column prop="Name" label="Name" style="font-size: 18px;"> </el-table-column>

			</el-table>
			<el-pagination align="right" @current-change="currentChange" :current-page="page" :page-size="10" background
				layout="total, prev, pager, next, jumper" :total="total" />

		</el-dialog>
	</div>
</template>
<script>
	import vis from 'vis-network/dist/vis-network.min.js';
	import 'vis-network/dist/dist/vis-network.min.css';

	export default {
		data() {
			return {
				tableData: [],
				formInline: {
					user: '',
					region: ''
				},
				nodes: [],
				edges: [],
				lengt: [],
				typer: false,
				network: [],
				BrowseDisabled: true,
				SubmitDisabled: true,
				SelectType: '',
				dialogTableVisible: false,
				showData: [],
				key: '',
				page: 1,
				size: 10,
				loading: false,
				CHEMBL_ID: '',
				total: 0,
			}
		},
		methods: {
			keychange() {
				this.page = 1;
				this.queryChembl()
			},
			currentChange(num) {
				this.page = num;
				this.queryChembl()
			},
			selectChembl(id) {
				this.CHEMBL_ID = id
				this.SubmitDisabled = false
				this.dialogTableVisible = false
			},
			selectTypeChange(e) {
				if (this.SelectType != '') {
					this.BrowseDisabled = false
				}
			},
			browseClick() {
				let _this = this
				_this.loading = true;
				_this.dialogTableVisible = true
				_this.showData = []
				_this.page = 1
				_this.key = ''
				_this.queryChembl()
			},
			queryChembl() {
				let _this = this
				var form = {
					key: _this.key,
					page: _this.page,
					size: _this.size,
					type: _this.SelectType
				};
				_this.$http({
					url: "/api/rdkit/queryChembl",
					params: form,
					method: "get",
				}).then((res) => {

					_this.showData = res.data.data.list
					_this.total = res.data.data.count
					if (!_this.showData.length) {
						_this.$message.warning("No Target matched");
					}
					_this.loading = false;
				});
			},
			getNetWorkData(){
				
			},
			onSubmit() {
				let _this = this
				var form = {
					npid: _this.CHEMBL_ID,
				};
				if(_this.CHEMBL_ID == ''){
					_this.$message.warning("SELECT CHEMBL_ID");
					return;
				}
				_this.nodes = [];
				_this.edges =[];
				_this.cavs();
				const loading = _this.$loading({
				  lock: true,
				  text: 'Loading',
				  spinner: 'el-icon-loading',
				  background: 'rgba(255, 255, 255, 0.7)'
				});
				_this.$http({
					url: "/api/rdkit/queryTargetByNp",
					params: form,
					method: "get",
				}).then((res) => {
					loading.close();
					if(res.data.data.nodes.length>0){
						_this.nodes = res.data.data.nodes
						_this.edges = res.data.data.edges
						_this.cavs();
					}else{
						_this.$message.warning("No data");
						return;
					}
					
					
				});
			},
			cavs() {
				// 创建节点数组
				var nodes = new vis.DataSet(this.nodes);
				// 创建关系数组
				var edges = new vis.DataSet(this.edges);
				// 创建一个网络
				var container = document.getElementById('mynetwork');
				// vis数据
				var data = {
					nodes: nodes,
					edges: edges
				};
				var options = {
					nodes: {
						shape: "dot",
						size: 12,
						font: {
							size: 15,
						},
						borderWidth: 2,
						shadow: true,
					},
					edges: {
						width: 2,
						shadow: true,
					},
					interaction: {
						navigationButtons: true,
						keyboard: true,
					},
					physics: {
						enabled: false
					},
					autoResize: true,
					height: '100%',
					width: '100%',
					configure: {
						showButton: false,
						filter: function(option, path) {


							if (path.indexOf("smooth") !== -1 || option === "smooth") {
								return true;
							}
							if (path.indexOf("font") !== -1) {
								return true;
							}

							if (path.indexOf("barnesHut") !== -1) {
								return true;
							}


							return false;
						},
						container: document.getElementById("config"),
					},
				};
				// 初始化网络
				this.network = new vis.Network(container, data, options);
				let that = this;
				this.network.on('click', function(params) {
					if (params.nodes.length == 0) {
						if (that.typer == '1') {
							const center = params.pointer.canvas;
							let nodes = that.nodes;
							const id = that.processUUID();
							let json = {};
							json.id = id;
							json.shape = 'box';
							json.x = center.x;
							json.y = center.y;
							json.data = ['一些数据什么的'];
							json.label = `节点 ${(nodes.length*1)+1}`;
							// json.name = ((nodes.length*1)+1)*1111;
							nodes.push(json);
							that.nodes = nodes;
							that.lengt = [];
							that.cavs();
							that.typer = false;
							return;
						}
					}
					// that.network.addNodeMode();
				});
				this.network.on("selectNode", function(params) {
					if (that.typer == '3') {
						let data = that.nodes;
						data.map((item, index) => {
							if (item.id == params.nodes[0]) {
								data.splice(index, 1);
							}
						});
						that.nodes = data;
						that.cavs();
						// that.network.deleteSelected();
						that.typer = false;
					}
				});
				this.network.on('dragEnd', function(params) {
					if (params.nodes.length == 0) {
						console.log('拖动的是空白处');
					} else {
						let nodes = that.nodes;
						nodes.forEach(item => {
							if (item.id == params.nodes[0]) {
								item.x = params.pointer.canvas.x;
								item.y = params.pointer.canvas.y;
							}
						});
						that.nodes = nodes
					}
				});
				this.network.moveTo({ //固定布局位置
					position: {
						x: 0,
						y: 0
					},
				});
			},
			ClickSwitchState(e) {
				if (e == '2') {
					this.network.addEdgeMode();
				}
				this.typer = this.typer == e ? false : e;
			},
			processUUID() {
				const urid = 'yxx-xyx-xxy-xxxx'.replace(/[xy]/g, function(a) {
					const b = Math.random() * 13 | 0,
						c = a == 'x' ? b : (b & 0x3 | 0x8);
					return c.toString(16);
				})
				return urid;
			},
			isClosedLine(edge) {
				if (edge.from == edge.to) {
					return false;
				} else {
					const iterator = (key, aimKey) => {
						let edges = this.edges;
						edges.push({
							from: key,
							to: aimKey
						});
						this.edges = edges,
							this.cavs();
						this.typer = false;
					};
					iterator(edge.from, edge.to);
				}
			}

		},
		mounted() {
			this.cavs();
		}
	}
</script>
<style>
	div.vis-configuration.vis-config-item {
		width: 410px !important;
	}
</style>
<style scoped>
	.network {
		padding: 0 50px;
		margin: 0 auto;
	}

	.intro {
		margin: 0 0 30px 0;
	}

	.intro h2 {
		margin-bottom: 10px;
		border-bottom: 2px solid rgb(245, 166, 20);
		text-align: center;
		line-height: 60px;
		font-size: 30px;
		color: #409EFF;
	}

	.intro p {
		padding: 10px 20px;
		margin: 0 0 10px 0;
		background: #F5F7F9;
		border-radius: 4px;
	}

	.mainContent {
		overflow: hidden;
	}

	.mainContent .nodes {
		float: left;
		width: 100%;
		max-height: 600px;
		overflow-y: scroll;
		border: 1px solid #d3d3d3;
	}

	.mainContent .legend {
		float: right;
		width: 100%;
		height: 600px;

		border: 1px solid #d3d3d3;
	}

	#legend1 {
		position: absolute;
		width: 15%;
	}

	.legend2 {
		background: #fff;
		width: 171px;
		border: .5px solid #eee;
		margin-left: 12px;
		margin-top: 11px;
		padding-left: 0;
		font-size: 100% !important;
	}

	.lili {
		list-style: none;
		height: 32px;
	}

	.lili div {
		margin-left: 10px;
		margin-right: 5px;
		width: 20px;
		height: 20px;
		vertical-align: middle;
		border-radius: 50%;
		display: inline-block;
	}
</style>
